import { render, staticRenderFns } from "./callPhone.vue?vue&type=template&id=78549a2e&scoped=true"
import script from "./callPhone.vue?vue&type=script&lang=js"
export * from "./callPhone.vue?vue&type=script&lang=js"
import style0 from "./callPhone.vue?vue&type=style&index=0&id=78549a2e&prod&lang=less&scoped=true"
import style1 from "./callPhone.vue?vue&type=style&index=1&id=78549a2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78549a2e",
  null
  
)

export default component.exports